import _range from 'lodash/range';

import IndeedBottomSemiCircle from '@/assets/icons/bottom_semicircle.svg';
import IndeedLeftSemiCircle from '@/assets/icons/left_semicircle.svg';
import IndeedRightSemiCircle from '@/assets/icons/right_semicircle.svg';

export function Receipt({ children }: { children: React.ReactNode }) {
  return (
    <div className="border-fx-neutral-200 relative flex h-fit min-h-[200px] w-[320px] flex-col gap-4 rounded-sm border bg-white py-4">
      {children}

      {/* Left semicircle */}
      <img
        src={IndeedLeftSemiCircle}
        alt="left semicircle cutout"
        className="absolute bottom-16 -left-px"
      />

      {/* Right semicircle */}
      <img
        src={IndeedRightSemiCircle}
        alt="right semicircle cutout"
        className="absolute -right-px bottom-16"
      />

      {/* Bottom semicircles */}
      {_range(20).map((_, i) => (
        <img
          // eslint-disable-next-line react/no-array-index-key
          key={`bottom-semicircle-${i}`}
          src={IndeedBottomSemiCircle}
          alt="bottom semicircle cutout"
          className="absolute -bottom-px"
          style={{ left: `${24 + i * 12.5}px` }}
        />
      ))}
    </div>
  );
}
